import React, { useMemo } from 'react';
import {
  TextInput,
  Divider,
  UI_BODY_SEMIBOLD_SM,
  icons,
  DropdownMulti,
} from "oolib";
import { getVal, setVal } from "oolib";
import { useQueryClient } from 'react-query';
import styled from "styled-components";
import { WidgetHeader } from '../WidgetBarChart/WIDGET_ELEM_ConfigForm';
import { getTplsWithAnnosEnabled } from '@/components/analysisModules/AnnotationExplorer/useGetAnnotationExplorerData';
import { WidgetFilters } from '../utils/WidgetFilters';

const { FileText, CaretRight } = icons;

const StyledFormSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const ConfigForm = ({
  thisWidgetConfig,
  setConfig,
  underEditWidgetIdx,
}) => {
  const queryClient = useQueryClient();
  const allTpls = queryClient.getQueryData("allTpls");

  const dataKeys = {
    title: "props.title",
    selectedContentTypes: "props.selectedContentTypes",
    displaySettings: "props.displaySettings",
  };

  const tplOptions = useMemo(() => {
    return getTplsWithAnnosEnabled({ allTpls });
  }, [allTpls]);

  const tplOptionsDropdownData = tplOptions.map((d) => ({
    display: d.general?.content?.title || d.kp_content_type,
    value: d.kp_content_type,
  }));

  const selectedContentTypes = useMemo(() => {
    return getVal(thisWidgetConfig, dataKeys.selectedContentTypes) || [];
  }, [thisWidgetConfig]);

  // selectedContentTypes are {display, value} objects (DropdownMulti w/o saveValueAsString)
  const selectedContentTypeValues = useMemo(
    () => selectedContentTypes.map((o) => o?.value ?? o),
    [selectedContentTypes]
  );

  const updateConfig = (key, value) => {
    setConfig((prev) => {
      let modifiedConfig = JSON.parse(
        JSON.stringify(prev[underEditWidgetIdx])
      );

      modifiedConfig = setVal(
        modifiedConfig,
        key,
        value
      );

      const modifiedFullConfig = JSON.parse(JSON.stringify(prev));
      modifiedFullConfig[underEditWidgetIdx] = modifiedConfig;
      return modifiedFullConfig;
    });
  };

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '1.4rem'}}>
      
      <WidgetHeader title="Highlights" type="Widget" icon="File" />

      <TextInput
        id={dataKeys.title}
        label="Custom widget title"
        placeholder="Enter title"
        value={getVal(thisWidgetConfig, dataKeys.title) || "Highlights"}
        onChange={(k, v) => updateConfig(dataKeys.title, v)}
      />

      <Divider style={{ margin: "0 -1.6rem" }}/>

      <StyledFormSection>
        <UI_BODY_SEMIBOLD_SM>Annotations from</UI_BODY_SEMIBOLD_SM>
        <DropdownMulti
          key={`content-types-${underEditWidgetIdx}`}
          options={tplOptionsDropdownData}
          value={selectedContentTypes}
          onChange={(k, v) => updateConfig(dataKeys.selectedContentTypes, v)}
          placeholder="Select content types"
        />
      </StyledFormSection>
      {selectedContentTypes.length >= 1 && (
        <WidgetFilters
          widgetConfig={thisWidgetConfig}
          updateWidgetConfig={setConfig}
          widgetIndex={underEditWidgetIdx}
          selectedTpls={tplOptions}
          contentTypesForFilters={selectedContentTypeValues}
          configPath={dataKeys.displaySettings}
          label="Configure Options"
          shouldShowFilters={selectedContentTypes.length >= 1}
        />
      )}
    </div>
  );
}; 